import { IMenuResponse } from '../../types/components/menu';
import { IMenuStateItem, TSaveMenuChange, TSaveMenuData } from '../../types/redux/menu';

export const SAVE_MENU_CHANGE = 'SAVE_MENU_CHANGE';
export const SAVE_MENU_DATA = 'SAVE_MENU_DATA';

export const saveMenuChange = (payload: IMenuStateItem): TSaveMenuChange => ({
    type: SAVE_MENU_CHANGE,
    payload,
});

export const saveMenuData = (payload: IMenuResponse): TSaveMenuData => ({
    type: SAVE_MENU_DATA,
    payload,
});
